var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7148 20.7853C11.1882 20.7853 11.572 20.4015 11.572 19.9282L11.572 11.642H20.429C20.9024 11.642 21.2861 11.2583 21.2861 10.7849C21.2861 10.3115 20.9024 9.92773 20.429 9.92773H11.572L11.572 1.07101C11.572 0.597624 11.1882 0.213867 10.7148 0.213867C10.2415 0.213867 9.8577 0.597624 9.8577 1.07101L9.8577 9.92773H1.57185C1.09846 9.92773 0.714705 10.3115 0.714705 10.7849C0.714705 11.2583 1.09846 11.642 1.57185 11.642H9.8577L9.8577 19.9282C9.8577 20.4015 10.2415 20.7853 10.7148 20.7853Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBtn);
export default __webpack_public_path__ + "static/media/PlusBtn.b749fd81abe2a1ed23cbe5eac593500f.svg";
export { ForwardRef as ReactComponent };